import * as endpoints from './endpoints';

const AppointmentService = { ...endpoints };

export default AppointmentService;
export type { RequestAppointmentOpts } from './endpoints';
